import makeStyles from '@material-ui/core/styles/makeStyles'

const useNewVendorStyle = makeStyles((theme) => ({
  paper: {
    padding: '3rem',
  },
}))

export { useNewVendorStyle }
